module.exports = __webpack_public_path__ + "img/5-2.ab2966d9.png";